module.exports = __webpack_public_path__ + "img/Error.31220c68.svg";